import { createStore } from "vuex";
import ApiService from '../services/'
export default createStore({
    state: {
        tokenPrice: 0,
        balance: 0,
        reduceTime: 0,
        username: null,
        selectedCaptain: null,
        inventory: null,
        selectedShip: null,
        selectedSupply: null,
        selectedPet: null,
        selectedFoods: [],
        division: [],
        attackData: [],
        dailyWinners: null,
        myAssets: null,
        stakes: null,
        level: 0,
        market: null,
    },
    actions: {
        getUsage: function({ commit }, assets) {
            assets.map((nft, i) => {
                ApiService.getItemUsage(nft.asset_id, (row) => {
                    assets[i].usage = row.usage;
                }, null);
            })
            commit("addInventory", assets);
        },
        getDivision: function({ commit }, did) {
            ApiService.getTable("divisions", did.division_id, (row) => {
                commit("addDivision", row.rows[0]);
            }, null);
        },
        stakeNfts: function({ commit }, assets) {
            ApiService.getAssetById(assets.captain, (row) => {
                commit("setCaptain", row.data.data);
            }, null);
            ApiService.getAssetById(assets.ship, (row) => {
                commit("setShip", row.data.data);
            }, null);
            ApiService.getAssetById(assets.supply, (row) => {
                commit("setSupply", row.data.data);
            }, null);
        },
        getBagData: function(state) {
            ApiService.getUserBag(async(row) => {
                if (row) {
                    state.selectedWeapons = row.weapons.join(', ')
                    let nfts = `${state.selectedWeapons},${row.userchar}`
                    state.userBag = await ApiService.setCards(nfts, row.userchar)
                }
            })
        },
        getMyAssets: function({ commit }, params) {
            ApiService.getAssets(params, (rows) => {
                if (rows) {
                    commit("setMyAssets", rows);
                }
            })
        },
        getSingleMarket: function({ commit, state }, params) {
            if (state.market) {
                const market = state.market.filter(item => item.asset_t == params.tempId);
                commit("addMarket", market);
            } else {
                ApiService.market((res) => {
                    const market = res.filter(item => item.asset_t == params.tempId);
                    commit("addMarket", market);
                });
            }
        },
        getTempateImage: function({ commit }, params) {
            ApiService.getByTempleteId(params.reward, (res) => {
                if (res.data.data) {
                    commit("updateRewardTemplate", { account: params.account, image: res.data.data.immutable_data.img });
                }
            });
        }
    },
    mutations: {
        addDivision: function(state, rows) {
            state.division = rows
        },
        setMyAssets: function(state, rows) {
            state.myAssets = rows
        },
        setCaptain: function(state, row) {
            state.captain = row
        },
        setPet: function(state, row) {
            state.selectedPet = row
        },
        setShip: function(state, row) {
            state.ship = row
        },
        setSupply: function(state, row) {
            state.supply = row
        },
        addBalance(state, val) {
            if (val) {
                val = parseFloat(val.toString());
                state.balance = val
            }
        },
        addLevel(state, val) {
            if (val) {
                val = parseFloat(val.toString());
                state.level = val
            }
        },
        addUser(state, val) {
            state.username = Number(val)
        },
        addCard(state, val) {
            if (val.schema.schema_name == "ships") {
                state.selectedShip = val.data;
                state.selectedShip.asset_id = val.asset_id;
            }
            if (val.schema.schema_name == "captains") {
                state.selectedCaptain = val.data;
                state.selectedCaptain.asset_id = val.asset_id;
            }
            if (val.schema.schema_name == "supplies") {
                state.selectedSupply = val.data;
                state.selectedSupply.asset_id = val.asset_id;
            }
            if (val.schema.schema_name == "foods") {
                let d = val.data;
                d.asset_id = val.asset_id;
                if (state.selectedFoods) {
                    state.selectedFoods.push(d);
                } else {
                    state.selectedFoods = [d];
                }
            }
            if (val.schema.schema_name == "pets") {
                state.selectedPet = val.data;
                state.selectedPet.asset_id = val.asset_id;
            }
        },
        addInventory(state, val) {
            state.inventory = val;
        },
        updateBalance(state, val) {
            state.balance = Number(state.balance) + Number(val)
        },
        decrementBalance(state, val) {
            state.balance = Number(state.balance) - Number(val)
        },
        addMarket(state, val) {
            state.market = val
        },
    },
    getters: {
        balance: state => {
            if (state.balance) {
                let numberVal = state.balance
                return new Intl.NumberFormat().format(numberVal)
            }
            return 0;
        },
        level: state => state.level,
        tokenPrice: state => {
            if (state.tokenPrice) {
                let numberVal = state.tokenPrice
                return parseFloat(numberVal)
            }
            return 0;
        },
        myAssets: state => state.myAssets,
        username: state => state.username,
        dailyWinners: state => {
            if (state.dailyWinners) {
                return state.dailyWinners
            }
        },
        selectedPet: state => state.selectedPet,
        selectedCaptain: state => state.selectedCaptain,
        selectedShip: state => state.selectedShip,
        selectedFoods: state => state.selectedFoods,
        selectedSupply: state => state.selectedSupply,
        market: state => state.market,
        division: state => state.division,
        waitData: state => {
            return [state.captain, state.ship, state.supply];
        },
        inventory: state => state.inventory,
        attackData: state => {
            state.attackData = state.selectedFoods.map(obj => {
                return obj.asset_id
            })
            if (state.selectedCaptain)
                state.attackData.push(state.selectedCaptain.asset_id);
            if (state.selectedShip)
                state.attackData.push(state.selectedShip.asset_id);
            if (state.selectedSupply)
                state.attackData.push(state.selectedSupply.asset_id);
            if (state.selectedPet)
                state.attackData.push(state.selectedPet.asset_id);
            return state.attackData;
        }
    }
});